module.exports = __webpack_public_path__ + "img/creative-monetization.ad5578bc.png";